(function () {
  if (window.BFL) { window.BFL.boot(); return; }
  var BFL = window.BFL = {};
  var applied = {};
  var cart = null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(c) { return '$' + (Math.max(0, c) / 100).toFixed(2); }
  function pad(n) { return ('0' + n).slice(-2); }
  function json(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); });
  }

  // Discount: sets the checkout discount cookie, then also writes it onto the cart via the Ajax API.
  function applyDiscount(code) {
    if (!code || applied[code]) return Promise.resolve();
    applied[code] = true;
    return fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' })
      .catch(function () {})
      .then(function () { return json(root + 'cart/update.js', { method: 'POST', body: JSON.stringify({ discount: code }) }).catch(function () {}); });
  }
  BFL.applyDiscount = applyDiscount;

  function toast(msg) {
    var t = document.querySelector('.bfl-toast');
    if (!t) { t = document.createElement('div'); t.className = 'bfl-toast bfl'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('on');
    clearTimeout(BFL._tt); BFL._tt = setTimeout(function () { t.classList.remove('on'); }, 2200);
  }

  function qtyByVariant() {
    var m = {};
    (cart && cart.items || []).forEach(function (i) { m[i.variant_id] = (m[i.variant_id] || 0) + i.quantity; });
    return m;
  }

  function paint() {
    var q = qtyByVariant();
    document.querySelectorAll('[data-bfl-atc]').forEach(function (b) {
      if (b.hasAttribute('disabled')) return;
      var n = q[b.getAttribute('data-variant-id')] || 0;
      var tpl = b.getAttribute('data-added-label') || 'added ([n]) — add another';
      var lbl = b.querySelector('[data-bfl-atc-label]') || b;
      lbl.textContent = n ? tpl.replace('[n]', n) : b.getAttribute('data-label');
    });
    document.querySelectorAll('[data-bfl-sticky]').forEach(function (s) {
      var count = cart ? cart.item_count : 0;
      var total = cart ? cart.total_price : 0;
      var th = Number(s.getAttribute('data-threshold') || 0) * 100;
      var left = th - total;
      var ship = s.querySelector('[data-bfl-ship]');
      if (ship) {
        ship.hidden = !count || !th;
        ship.querySelector('[data-bfl-ship-msg]').textContent = left > 0 ? (s.getAttribute('data-ship-away') || "you're [amount] away from free shipping").replace('[amount]', money(left)) : (s.getAttribute('data-ship-done') || 'you unlocked free shipping');
        ship.querySelector('i').style.width = Math.min(100, th ? total / th * 100 : 0) + '%';
      }
      s.querySelector('[data-bfl-kicker]').textContent = count ? count + ' ITEM' + (count > 1 ? 'S' : '') + ' — VIEW CART' : s.getAttribute('data-empty-kicker');
      s.querySelector('[data-bfl-value]').textContent = count ? money(total) : s.getAttribute('data-empty-value');
      s.querySelector('[data-bfl-go]').textContent = count ? s.getAttribute('data-checkout-label') : s.getAttribute('data-empty-cta');
      s.classList.toggle('has-items', !!count);
    });
  }

  function refresh() {
    return json(root + 'cart.js').then(function (r) { if (r.ok) { cart = r.data; paint(); } return cart; }).catch(function () {});
  }
  BFL.refresh = refresh;

  function updateBubble(sections) {
    if (!sections || window.aftersell) return;
    var html = sections['cart-icon-bubble'];
    var el = document.getElementById('cart-icon-bubble');
    if (html && el) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var src = d.querySelector('.shopify-section') || d.body;
      el.innerHTML = src.innerHTML;
    }
  }

  function openCart() {
    if (window.aftersell && window.aftersell.cart && typeof window.aftersell.cart.open === 'function') { window.aftersell.cart.open(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) { icon.click(); return; }
    window.location.href = root + 'cart';
  }

  function scrollToSel(sel) {
    var el = sel && document.querySelector(sel);
    if (!el) return;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
  }

  function onAtc(btn) {
    var id = btn.getAttribute('data-variant-id');
    var code = (btn.getAttribute('data-code') || '').trim();
    if (!id) return;
    btn.setAttribute('disabled', '');
    var btnLbl = btn.querySelector('[data-bfl-atc-label]') || btn;
    btnLbl.textContent = btn.getAttribute('data-adding-label') || 'adding...';
    applyDiscount(code)
      .then(function () {
        var item = { id: Number(id), quantity: 1 };
        var plan = btn.getAttribute('data-selling-plan');
        if (plan) item.selling_plan = Number(plan);
        return json(root + 'cart/add.js', { method: 'POST', body: JSON.stringify({ items: [item], sections: 'cart-icon-bubble', sections_url: window.location.pathname }) });
      })
      .then(function (res) {
        btn.removeAttribute('disabled');
        if (!res.ok) {
          btnLbl.textContent = 'unavailable';
          setTimeout(paint, 2500);
          return;
        }
        updateBubble(res.data && res.data.sections);
        if (code) json(root + 'cart/update.js', { method: 'POST', body: JSON.stringify({ discount: code }) }).catch(function () {});
        return refresh().then(function () {
          var s = document.querySelector('[data-bfl-sticky]');
          var th = s ? Number(s.getAttribute('data-threshold') || 0) * 100 : 0;
          if (th && cart) {
            var left = th - cart.total_price;
            toast(left > 0 ? 'ADDED — ' + money(left) + ' FROM FREE SHIPPING' : 'ADDED — FREE SHIPPING UNLOCKED');
          } else toast('ADDED TO CART');
          var behavior = btn.getAttribute('data-behavior');
          if (behavior === 'drawer') openCart();
          else if (behavior === 'cart') window.location.href = root + 'cart';
          else if (behavior === 'checkout') window.location.href = root + 'checkout' + (code ? '?discount=' + encodeURIComponent(code) : '');
        });
      })
      .catch(function () { btn.removeAttribute('disabled'); paint(); });
  }

  function initCountdowns() {
    document.querySelectorAll('[data-bfl-cd]').forEach(function (el) {
      if (el.dataset.bflInit) return;
      el.dataset.bflInit = '1';
      var end = Date.parse(el.getAttribute('data-end'));
      if (isNaN(end)) return;
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var tick = function () {
        var ms = Math.max(0, end - Date.now());
        d.textContent = pad(Math.floor(ms / 864e5));
        h.textContent = pad(Math.floor(ms / 36e5) % 24);
        m.textContent = pad(Math.floor(ms / 6e4) % 60);
        s.textContent = pad(Math.floor(ms / 1e3) % 60);
      };
      tick(); setInterval(tick, 1000);
    });
  }

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-bfl-atc]');
    if (atc) { e.preventDefault(); onAtc(atc); return; }
    var copy = e.target.closest('[data-bfl-copy]');
    if (copy) {
      e.preventDefault();
      var label = copy.getAttribute('data-label'), done = copy.getAttribute('data-copied');
      var fin = function () { copy.textContent = done; setTimeout(function () { copy.textContent = label; }, 2000); };
      try { navigator.clipboard.writeText(copy.getAttribute('data-bfl-copy')).then(fin, fin); } catch (x) { fin(); }
      applyDiscount(copy.getAttribute('data-bfl-copy'));
      return;
    }
    var go = e.target.closest('[data-bfl-go]');
    if (go) {
      e.preventDefault();
      var s = go.closest('[data-bfl-sticky]');
      if (cart && cart.item_count) {
        var code = s.getAttribute('data-code');
        window.location.href = root + 'checkout' + (code ? '?discount=' + encodeURIComponent(code) : '');
      } else scrollToSel(s.getAttribute('data-empty-target'));
      return;
    }
    var sum = e.target.closest('[data-bfl-sum]');
    if (sum) {
      e.preventDefault();
      if (cart && cart.item_count) openCart();
      else scrollToSel(sum.closest('[data-bfl-sticky]').getAttribute('data-empty-target'));
    }
  });

  ['aftersell:cart.change', 'cart:updated', 'cart:refresh'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(refresh, 150); }); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });

  BFL.boot = function () { initCountdowns(); refresh(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', BFL.boot); else BFL.boot();
  document.addEventListener('shopify:section:load', BFL.boot);
})();